import React from 'react';
import { connect } from 'react-redux';
import { preprocessTripObject, isRoundTrip } from 'app/utils/trip';
import { formValueSelector } from 'redux-form';
import { BOOK_TRIP_FORM, DEPARTING_TRIP_FIELD_NAME } from 'app/constants';
import { Layout } from 'app/components/base/Layout';
import Icon from 'app/components/base/Icon';
import InteractiveInfoBlock from 'app/components/base/InteractiveInfoBlock';
import { FormattedMessage } from 'translations';
import classnames from 'classnames';

import style from './style.css';

const messages = {
  title: { id: 'BOOK_TRIP.UPGRADES.INSURANCE_COVERAGE_LABEL' },
  included: { id: 'BOOK_TRIP.UPGRADES.UPGRADE_INCLUDED_LABEL' }
};

const subtextByType = {
  airport: { id: 'BOOK_TRIP.UPGRADES.INSURANCE_COVERAGE_CAPTION' },
  train_station: { id: 'BOOK_TRIP.UPGRADES.INSURANCE_COVERAGE_CAPTION_TRAIN' }
}

/**
 * Static component that shows a banner telling the
 * trip is insured against flight delays. Used in BTP.
 */
export const InsuranceCoverage = ({ waitingTime, fromType }) => {
  if (!waitingTime) return null;

  return (
    <InteractiveInfoBlock type="white">
      <Layout align="space-between center" size="grow">
        <Layout size="70" align="start center" nowrap>
          <Icon
            large
            family="mozio"
            name="upgrade-insurance"
            className={classnames(style.icon, style['fixed-height'])}
          />
          <Layout direction="column">
            <span className={style.title}>
              <FormattedMessage {...messages.title} />
            </span>
            <span className={style.subtext}>
              <FormattedMessage
                {...(subtextByType[fromType] || subtextByType.airport)}
                values={{ waitingTime }}
              />
            </span>
          </Layout>
        </Layout>

        <Layout align="end center" className={style.included} size="noshrink">
          <FormattedMessage {...messages.included} />
          <Icon className={style.check} name="sb-check" family="mozio" />
        </Layout>
      </Layout>
    </InteractiveInfoBlock>
  );
};

// TODO: move to Flow types
// InsuranceCoverage.propTypes = {
//   mobile: PropTypes.bool,
//   waitingTime: PropTypes.object
// };

export const mapStateToProps = (state) => {
  const selector = formValueSelector(BOOK_TRIP_FORM);
  const trip = selector(state, DEPARTING_TRIP_FIELD_NAME);
  const preparedTrip = preprocessTripObject(trip);
  if (!preparedTrip) {
    return { waitingTime: 0, fromType: 'airport' }
  }

  const { detailedWaitingTime } = preparedTrip.details
  let waitTimeObj = null

  if (preparedTrip.routing.fromIataCode && detailedWaitingTime.direct) {
    waitTimeObj = detailedWaitingTime.direct
  } else if (isRoundTrip(trip) && preparedTrip.routing.toIataCode) {
    waitTimeObj = detailedWaitingTime.return
  }

  return {
    waitingTime: waitTimeObj?.minutes || 0,
    fromType: waitTimeObj?.fromType || ''
  }
};

export default connect(mapStateToProps)(InsuranceCoverage);
